// Dashboards layout
// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

// shared components
import PageContainer from '@/components/layout/PageContainer';

// components
import ErrorBoundary from '@/routes/-ErrorBoundary';

export const Route = createFileRoute('/$accountId/_user/dashboards')({
  component: () => (
    <PageContainer maxWidth="xl">
      <Outlet />
    </PageContainer>
  ),
  errorComponent: ErrorBoundary,
});
